"use client";

import { Award, Coffee, Leaf } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TrayectoriaProfesional() {
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stats = [{
    label: "HABILITACIÓN SANITARIA",
    title: "PRÁCTICA CLÍNICA",
    body: "Psicólogo general sanitario y psicoanalista (M-41326). Miembro del Colegio de Psicoanálisis de Madrid.",
    Icon: Award
  }, {
    label: "LICENCIADO EN FILOLOGÍA HISPÁNICA",
    title: "CAMPO DE LA PALABRA Y DEL LENGUAJE",
    body: "Mi\xA0 formación en Filología Hispánica ahondó en algo que hoy sigue orientando mi práctica: las palabras no se agotan en su significado más evidente. Suelen decir algo más de lo que creemos decir.",
    Icon: Coffee
  }, {
    label: "UNA CLÍNICA DEL CASO POR CASO",
    title: "CADA HISTORIA ES ÚNICA",
    body: "En psicoanálisis no existe el sujeto promedio. La clínica se construye en el caso por caso.",
    Icon: Leaf
  }];
  const tickerItems = ["PSICOANÁLISIS EN MADRID", "ADULTOS / ADOLESCENTES", "CONSULTA PSICOLÓGICA", "PSICOANÁLISIS EN MADRID", "ADULTOS / ADOLESCENTES", "CHAMBERÍ", "PSICOANÁLISIS EN MADRID", "ADULTOS / ADOLESCENTES", "PSICÓLOGO SANITARIO"];
  return <section data-section-id="1536" id="trayectoria-profesional" className="relative overflow-hidden py-28 md:py-36 bg-background text-foreground" style={{
    borderTop: "1px solid var(--border)",
    borderBottom: "1px solid var(--border)"
  }}>
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
      backgroundImage: "radial-gradient(var(--border) 0.5px, transparent 0.5px)",
      backgroundSize: "24px 24px",
      opacity: 0.2
    }} />

      <div className="relative mx-auto max-w-[1280px] px-5 md:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-7">
            <div ref={headRef} className="transition-all duration-700 ease-out md:mb-12" style={{
            opacity: headVisible ? 1 : 0,
            transform: headVisible ? "translateY(0)" : "translateY(24px)",
            transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)"
          }}>
              <div className="font-mono uppercase mb-8" style={{
              color: "var(--muted-foreground)",
              fontSize: "0.75rem",
              letterSpacing: "0.15em"
            }}>
                § 02 <span className="mx-2 inline-block h-1.5 w-1.5 align-middle" style={{
                backgroundColor: "var(--ring)"
              }} /> TRAYECTORIA
              </div>

              <h2 className="font-default uppercase" style={{
              color: "var(--foreground)",
              fontSize: "clamp(2.5rem, 5.5vw, 5rem)",
              fontWeight: 300,
              letterSpacing: "-0.03em",
              lineHeight: 0.95
            }}>OTRA FORMA <span className="relative inline-block align-baseline px-3 py-1" data-ast-id="f:/src/pages/AboutMe/sections/Trajectory.tsx|sig:fjo0dc" data-ast-start="3305" data-ast-end="3545" style={{
                color: 'var(--foreground)',
                border: '1px solid var(--foreground)'
              }}>DE ESCUCHAR.</span></h2>
            </div>

            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714903/img/new_expressionist_landscape.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714903/img/new_expressionist_landscape.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714903/img/new_expressionist_landscape.png-wvc-sizes" alt="Antonio Heredia psicólogo y psicoanalista en metro Iglesia - Madrid" className="w-full aspect-[16/9] object-cover my-12 rounded-lg shadow-md" loading="lazy" decoding="async" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714903/img/andrescmostoles-madrid-5396217-scaled.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714903/img/clinical_texture_watermark.webp" src="https://popular-asp.10web.cloud/wp-content/uploads/2026/06/Bande_de_moebius.png" src="https://popular-asp.10web.cloud/wp-content/uploads/2026/06/fachadas-ricas-de-estilo-arquitectonico-barroco-con-ventanas-y-balcones-elegantes-en-el-distrito-central-chamberi-madrid-spain-277638696.jpg" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714903/img/publicaciones_clinicas.png" src="https://popular-asp.10web.cloud/wp-content/uploads/2026/06/jj-ying-7JX0-bfiuxQ-unsplash.jpg" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714903/img/andrescmostoles-madrid-5396217-scaled.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714903/img/abstract_warm_composition.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714903/img/forest.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714903/img/forest_path.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714903/img/andrescmostoles-madrid-5396217-scaled.png" src="https://antonioheredia.eu/wp-content/uploads/2026/06/andrescmostoles-madrid-5396217-scaled.jpg" src="https://antonioheredia.eu/wp-content/uploads/2026/07/robert-clark-aJhjYxQdflA-unsplash-scaled.jpg" src="https://antonioheredia.eu/wp-content/uploads/2026/07/jr-korpa-xIdpellCyxY-unsplash-scaled.jpg" src="https://antonioheredia.eu/wp-content/uploads/2026/07/jr-korpa-I8yPOHfMzVw-unsplash-scaled.jpg" src="https://antonioheredia.eu/wp-content/uploads/2026/07/rodion-kutsaiev-pVoEPpLw818-unsplash-scaled.jpg" src="https://antonioheredia.eu/wp-content/uploads/2026/07/jr-korpa-YXQew2KZjzY-unsplash-scaled.jpg" src="https://antonioheredia.eu/wp-content/uploads/2026/07/steve-a-johnson-UPnFr9OBPwQ-unsplash-scaled.jpg" src="https://antonioheredia.eu/wp-content/uploads/2026/07/jr-korpa-YXQew2KZjzY-unsplash-scaled.jpg" src="https://antonioheredia.eu/wp-content/uploads/2026/07/jr-korpa-YXQew2KZjzY-unsplash-scaled.webp" />

            <div ref={bodyRef} className="mt-10 md:mt-12 md:mb-10 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-[720px] transition-all duration-700 ease-out" style={{
            opacity: bodyVisible ? 1 : 0,
            transform: bodyVisible ? "translateY(0)" : "translateY(24px)",
            transitionDelay: bodyVisible ? "120ms" : "0ms",
            transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)"
          }}>
              <div>
                <p className="font-default leading-relaxed" style={{
                color: "var(--foreground)",
                fontSize: "clamp(1.125rem, 1.35vw, 1.375rem)",
                letterSpacing: "-0.005em"
              }}>
                  <span className="float-left mr-3 mt-1 inline-flex items-center justify-center font-default" style={{
                  border: "1px solid var(--foreground)",
                  width: "3.25rem",
                  height: "3.25rem",
                  fontSize: "2.25rem",
                  lineHeight: 1
                }}>
                    S
                  </span>
                  oy psicólogo general sanitario (M-41326), psicoanalista y licenciado en filología hispánica. <strong className="font-semibold">Con más de doce años de especialización en el Colegio de Psicoanálisis de Madrid</strong>, del que soy miembro activo, acompaño a adultos y adolescentes en el desciframiento de su propio malestar.
                </p>
              </div>
              <div>
                <p className="font-default leading-relaxed" style={{
                color: "var(--foreground)",
                fontSize: "clamp(1.125rem, 1.35vw, 1.375rem)",
                letterSpacing: "-0.005em"
              }}>
                  Mi labor no es dar consejos genéricos ni pautas de comportamiento, sino ayudarte a encontrar una posición distinta ante tu propia historia, facilitando un cambio real y duradero.
                </p>
              </div>
            </div>
          </div>

          <div ref={statsRef} className="lg:col-span-5">
            <div className="flex flex-col gap-6">
              {stats.map((stat, i) => {
              const Icon = stat.Icon;
              return <div key={stat.label} data-index={i} className="transition-all ease-out" style={{
                opacity: statsVisible ? 1 : 0,
                transform: statsVisible ? "translateY(0)" : "translateY(24px)",
                transitionDuration: "600ms",
                transitionDelay: statsVisible ? `${i * 120}ms` : "0ms",
                transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)"
              }}>
                    <Card className="p-8 md:p-10 gap-3 py-8 md:py-10 shadow-md hover:shadow-lg rounded-lg border-border/40 transition-shadow duration-300" style={{
                  backgroundColor: "var(--card)",
                  color: "var(--foreground)"
                }}>
                      <CardContent className="px-0 flex flex-col gap-3">
                        <div className="flex items-center justify-between gap-4">
                          <div className="font-mono uppercase" style={{
                        color: "var(--muted-foreground)",
                        fontSize: "0.75rem",
                        letterSpacing: "0.15em"
                      }}>
                            {stat.label}
                          </div>
                          <div className="flex h-11 w-11 items-center justify-center shrink-0" style={{
                        border: "1px solid var(--border)"
                      }}>
                            <Icon className="size-5" strokeWidth={1} style={{
                          color: "var(--foreground)"
                        }} />
                          </div>
                        </div>

                        <h3 className="font-default uppercase" style={{
                      color: "var(--foreground)",
                      fontSize: "clamp(1.25rem, 1.6vw, 1.75rem)",
                      fontWeight: 600,
                      letterSpacing: "-0.02em",
                      lineHeight: 1.0
                    }}>
                          {stat.title}
                        </h3>

                        <p className="font-default" style={{
                      color: "var(--muted-foreground)",
                      fontSize: "1rem",
                      lineHeight: 1.6
                    }}>
                          {stat.body}
                        </p>
                      </CardContent>
                    </Card>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>

      <div className="relative mt-20 md:mt-28 overflow-hidden" style={{
      borderTop: "1px solid var(--border)",
      borderBottom: "0"
    }} aria-hidden="true">
        <div className="flex whitespace-nowrap py-5" style={{
        animation: "roasteryTickerScroll 40s linear infinite",
        width: "max-content"
      }}>
          {tickerItems.concat(tickerItems).map((item, i) => <div key={i} data-index={i} className="flex items-center font-mono uppercase" style={{
          color: "var(--muted-foreground)",
          fontSize: "0.85rem",
          letterSpacing: "0.15em",
          paddingLeft: "1.5rem",
          paddingRight: "1.5rem"
        }}>
              <span>{item}</span>
              <span className="ml-8 inline-block h-1 w-1" style={{
            backgroundColor: "var(--ring)"
          }} />
            </div>)}
        </div>
      </div>

      <style>{`
        @keyframes roasteryTickerScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}